import React, {useState, useEffect} from 'react';
import UserStore from "../../store/user-store";
import {motion} from 'framer-motion';
import {pingServers} from "../../Hooks/Api/fetchAvailableServers";
import ConfigStore from "../../store/config-store";
import Lottie from "react-lottie";
import refreshAnimation from "../Lottie/refresh.json";

export const ServerFilter = ({servers, setFilteredServers}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name'); // 'name' or 'ping'
    const langCode = UserStore.langCode;
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        filterServers();
    }, []);

    useEffect(() => {
        filterServers();
    }, [searchTerm, sortBy]);

    const filterServers = () => {
        let result = [...servers];

        if (searchTerm) {
            result = result.filter(server =>
                server.server_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (sortBy === 'ping') {
            result.sort((a, b) => a.ping - b.ping);
        } else if (sortBy === 'name') {
            result.sort((a, b) => a.server_name.localeCompare(b.server_name));
        }

        setFilteredServers(result);
    };

    const buttonVariants = {
        hidden: {opacity: 0, y: -10},
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20
            }
        }
    };

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={{
                hidden: {},
                visible: {
                    transition: {
                        staggerChildren: 0.1
                    }
                }
            }}
            style={{
                marginBottom: '16px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
            }}
        >
            <motion.div
                variants={buttonVariants}
                style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <div style={{
                    position: 'absolute',
                    left: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M8.58268 1.2915C4.55561 1.2915 1.29102 4.55609 1.29102 8.58317C1.29102 12.6102 4.55561 15.8748 8.58268 15.8748C12.6098 15.8748 15.8743 12.6102 15.8743 8.58317C15.8743 4.55609 12.6098 1.2915 8.58268 1.2915ZM0.0410156 8.58317C0.0410156 3.86574 3.86525 0.0415039 8.58268 0.0415039C13.3001 0.0415039 17.1243 3.86574 17.1243 8.58317C17.1243 10.7169 16.342 12.668 15.0484 14.165L17.7746 16.8912C18.0187 17.1353 18.0187 17.531 17.7746 17.7751C17.5305 18.0192 17.1348 18.0192 16.8907 17.7751L14.1645 15.0489C12.6675 16.3424 10.7164 17.1248 8.58268 17.1248C3.86525 17.1248 0.0410156 13.3006 0.0410156 8.58317Z"
                              fill="#DBD6CE"/>
                    </svg>
                </div>
                <input
                    type="text"
                    placeholder={langCode === "ru" ? "Поиск" : "Search"}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                        backgroundColor: '#2D2F31',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        borderRadius: '8px',
                        padding: '16px 16px 16px 44px', // Added left padding for the icon
                        color: 'white',
                        fontSize: '16px',
                        width: '100%',
                        boxSizing: 'border-box',
                        // position: "relative"
                    }}
                />
            </motion.div>

            <motion.div
                variants={{
                    hidden: {},
                    visible: {
                        transition: {
                            staggerChildren: 0.1
                        }
                    }
                }}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '10px'
                }}
            >
                <div style={{display: 'flex', gap: '10px'}}>
                    <motion.button
                        variants={buttonVariants}
                        onClick={() => setSortBy('name')}
                        style={{
                            backgroundColor: sortBy === 'name' ? '#007AFF' : '#2D2F31',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                    >
                        {langCode === "ru" ? "По названию" : "By name"}
                    </motion.button>

                    <motion.button
                        variants={buttonVariants}
                        onClick={() => setSortBy('ping')}
                        style={{
                            backgroundColor: sortBy === 'ping' ? '#007AFF' : '#2D2F31',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                    >
                        {langCode === "ru" ? "По скорости" : "By speed"}
                    </motion.button>
                </div>
                <motion.button
                    disabled={isPlaying}
                    variants={buttonVariants}
                    onClick={() => {
                        setIsPlaying(true)
                        pingServers(servers, ConfigStore.setServers);
                    }}
                    style={{
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        cursor: 'pointer'
                    }}
                >
                    <Lottie
                        isPaused={!isPlaying}
                        options={{
                            loop: false,
                            autoplay: false,
                            animationData: refreshAnimation,

                        }}
                        eventListeners={[
                            {
                                eventName: 'complete',
                                callback: () => {
                                    setIsPlaying(false)
                                }
                            }
                        ]}
                    />
                </motion.button>

            </motion.div>
        </motion.div>
    );
}; 